// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OBTAccordionGroup2_wrapper__ZRSJd"};